import React from 'react';
import { ChevronLeftIcon, CameraIcon, DollarSignIcon } from 'lucide-react';
export const ApplicationPreparation = ({
  onBack,
  onNext
}) => {
  return <div className="flex flex-col p-6 flex-grow" data-id="element-117">
      <div className="flex items-center mb-6" data-id="element-118">
        <button onClick={onBack} className="mr-4" data-id="element-119">
          <ChevronLeftIcon size={24} data-id="element-120" />
        </button>
      </div>
      {/* Progress indicator */}
      <div className="flex items-center mb-8" data-id="element-121">
        <div className="h-1 w-24 bg-[#5c5cf5] rounded mr-1" data-id="element-122"></div>
        <div className="h-1 w-24 bg-gray-200 rounded mr-1" data-id="element-123"></div>
        <div className="h-1 w-24 bg-gray-200 rounded" data-id="element-124"></div>
      </div>
      <h1 className="text-2xl font-bold mb-2" data-id="element-125">Before we begin...</h1>
      <p className="text-gray-700 mb-6" data-id="element-126">
        To simplify the application and ID verification process, we recommend
        having the following items ready:
      </p>
      <div className="bg-gray-100 rounded-lg p-4 mb-4 flex items-start" data-id="element-127">
        <div className="bg-white p-2 rounded-lg mr-4" data-id="element-128">
          <CameraIcon size={24} data-id="element-129" />
        </div>
        <div data-id="element-130">
          <h3 className="font-bold" data-id="element-131">Photo ID</h3>
          <p className="text-gray-700" data-id="element-132">
            Either a Driver's License, Passport, or a State issued ID
          </p>
        </div>
      </div>
      <div className="bg-gray-100 rounded-lg p-4 mb-4 flex items-start" data-id="element-133">
        <div className="bg-white p-2 rounded-lg mr-4" data-id="element-134">
          <DollarSignIcon size={24} data-id="element-135" />
        </div>
        <div data-id="element-136">
          <h3 className="font-bold" data-id="element-137">Info to fund account</h3>
          <p className="text-gray-700" data-id="element-138">
            Existing account (account and routing number) or debit card
          </p>
        </div>
      </div>
      <div className="mt-auto" data-id="element-139">
        <button className="w-full bg-[#5c5cf5] text-white py-3 rounded-full font-medium" onClick={onNext} data-id="element-140">
          Next
        </button>
      </div>
    </div>;
};